export default __webpack_public_path__ + "static/media/img12.c9ddf40c.png";